export function selectableOrderStatuses<
  T extends { id: number; code?: string | null }
>(statuses: T[], currentId?: number | string | null): T[] {
  const current = statuses.find((s) => s.id === Number(currentId));
  const allowed: Record<string, string[]> = {
    DRAFT: ['DRAFT', 'SUBMITTED', 'CANCELLED'],
    SUBMITTED: ['SUBMITTED', 'IN_PROGRESS', 'CANCELLED'],
    IN_PROGRESS: ['IN_PROGRESS', 'COMPLETED', 'CANCELLED'],
    COMPLETED: ['COMPLETED'],
    INVOICED: ['INVOICED'],
    PAID: ['PAID'],
    CANCELLED: ['CANCELLED'],
  };
  const codes = current
    ? allowed[current.code ?? ''] ?? []
    : ['DRAFT', 'SUBMITTED'];
  return statuses.filter((s) => codes.includes(s.code ?? ''));
}
